(function(){
    var selector = '.attribute-progress-bar, .product-effect-progress-bar, .mark-when-in-viewport, .progress-circle';

    if (typeof IntersectionObserver != 'function') {
        document.querySelectorAll(selector).forEach(function(item){
            item.classList.add('in-view');
        })

        return false;
    }
    const observer = new IntersectionObserver((entries, observer) => {
        for (const entry of entries) {
            if (entry.isIntersecting) {
                // If the element is in the viewport, add the class to it.
                entry.target.classList.add('in-view');

                if (entry.target.classList.contains('progress-circle')) {
                    var handle = entry.target.querySelector('.handle');
                    handle.style.strokeDashoffset = handle.getAttribute('data-dash-offset');
                }
            } else {
                if (entry.target.classList.contains('progress-circle')) {
                    var handle = entry.target.querySelector('.handle');
                    handle.style.strokeDashoffset = 301.635;
                }
            }
        }
    }, {
        // The threshold defines how much of the element needs to be in the viewport before it is considered "intersecting".
        threshold: 0.5
    });

    // Add the observer to the element.
    document.querySelectorAll(selector).forEach(function(item){
        observer.observe(item);
    });
})();